import React from "react";
import HeadingForDashboardReusable from "../../../../reusable-components/headings/HeadingForDashboardReusable";
import {
  NOC_PRIMARY,
  NOC_SECONDARY,
} from "../../../../utilities/constants/colors";

const getBarColor = (pct) => {
  if (pct >= 11) return NOC_PRIMARY;
  if (pct >= 1) return NOC_SECONDARY;
  return "#6f8794";
};

const NocReportPaymentMode = ({ data }) => {
  const entries = Array.isArray(data) ? data : [];

  const total = entries.reduce(
    (sum, e) => sum + (Number(e.total_count) || 0),
    0,
  );

  return (
    <div>
      <HeadingForDashboardReusable
        title="NOC by Payment Mode"
        description="Overview of NOC applications categorized by payment mode."
      />

      <div className="w-full rounded-xl border border-slate-200 bg-white p-5 dark:border-slate-800 dark:bg-slate-900">
        <div className="space-y-5">
          {entries.map((entry) => {
            const value = Number(entry.total_count) || 0;
            const pct = total > 0 ? (value / total) * 100 : 0;

            const barColor = getBarColor(pct);

            // Keep a tiny visible bar even when value is 0
            const barWidth = value === 0 ? 2 : Math.max(pct, 3);

            return (
              <div key={entry.payment_mode}>
                {/* Label and value */}
                <div className="mb-2 flex items-center justify-between">
                  <span
                    className="text-sm font-medium"
                    style={{ color: NOC_PRIMARY }}
                  >
                    {entry.payment_mode}
                  </span>

                  <div className="flex items-center gap-2">
                    <span className="text-sm font-semibold text-slate-700 dark:text-slate-200">
                      {value.toLocaleString("en-IN")}
                    </span>

                    <span className="text-xs text-slate-400">
                      ({pct.toFixed(0)}%)
                    </span>
                  </div>
                </div>

                {/* Progress */}
                <div className="h-2 w-full overflow-hidden rounded-full bg-slate-100 dark:bg-slate-800">
                  <div
                    className="h-full rounded-full transition-all duration-500"
                    style={{
                      width: `${barWidth}%`,
                      backgroundColor: barColor,
                    }}
                  />
                </div>
              </div>
            );
          })}
        </div>

        {/* Total */}
        <div className="mt-6 flex items-center justify-between border-t border-slate-100 pt-4 dark:border-slate-800">
          <span className="text-xs font-medium uppercase tracking-wide text-slate-400">
            NOC Payments Received
          </span>

          <span className="text-base font-bold" style={{ color: NOC_PRIMARY }}>
            {total.toLocaleString("en-IN")}
          </span>
        </div>
      </div>
    </div>
  );
};

export default NocReportPaymentMode;
